module.exports = __webpack_public_path__ + "static/media/gt.bac56288.svg";